"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customizeFilters = exports.createHistoryTypeFilter = exports.filters = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const filters_1 = require("../filters");
const HistoryType = {
    type: 'type',
    order: -4,
    header: 'arcade.filter.historyType.label',
    key: 'HistoryType',
    value: 'historyType',
    selectionType: filters_1.SelectionType.MULTIPLE,
    filters: [
        {
            order: 0,
            isSelected: false,
            name: 'arcade.filter.historyType.pointsToTokens',
            value: 'POINTS_TO_TOKENS'
        },
        {
            order: 1,
            isSelected: false,
            name: 'arcade.filter.historyType.tokensPurchase',
            value: 'TOKENS_PURCHASE'
        },
        {
            order: 2,
            isSelected: false,
            name: 'arcade.filter.historyType.gameplay',
            value: 'GAMEPLAY'
        },
        {
            order: 3,
            isSelected: false,
            name: 'arcade.filter.historyType.winnings',
            value: 'WINNINGS'
        },
        {
            order: 4,
            isSelected: false,
            name: 'arcade.filter.historyType.sweepstakesEntries',
            value: 'SWEEPSTAKES_ENTRIES'
        },
        {
            order: 5,
            isSelected: false,
            name: 'arcade.filter.historyType.freeDailyBonus',
            value: 'FREE_DAILY'
        },
        {
            order: 6,
            isSelected: false,
            name: 'arcade.filter.historyType.other',
            value: 'OTHER'
        }
    ]
};
const DateFilter = {
    type: 'custom_date_range',
    key: 'DateFilter',
    order: -3,
    header: 'Show Last',
    value: 'status',
    selectionType: filters_1.SelectionType.SINGLE,
    filters: [
        {
            order: 0,
            isSelected: false,
            name: '1 MONTH',
            customDateFilterType: '1-month',
            customDateRangeStart: (0, moment_timezone_1.default)().subtract(1, 'months'),
            customDateRangeEnd: (0, moment_timezone_1.default)()
        },
        {
            order: 1,
            isSelected: false,
            name: '3 MONTHS',
            customDateFilterType: '3-months',
            customDateRangeStart: (0, moment_timezone_1.default)().subtract(3, 'months'),
            customDateRangeEnd: (0, moment_timezone_1.default)()
        },
        {
            order: 2,
            isSelected: false,
            name: '6 MONTHS',
            customDateFilterType: '6-months',
            customDateRangeStart: (0, moment_timezone_1.default)().subtract(6, 'months'),
            customDateRangeEnd: (0, moment_timezone_1.default)()
        },
        {
            order: 3,
            isSelected: false,
            name: '1 YEAR',
            customDateFilterType: '1-year',
            customDateRangeStart: (0, moment_timezone_1.default)().subtract(1, 'year'),
            customDateRangeEnd: (0, moment_timezone_1.default)()
        },
        {
            order: 4,
            isSelected: false,
            name: 'Custom Date Range',
            customDateFilterType: 'custom',
            customDateRangeStart: null,
            customDateRangeEnd: null
        }
    ]
};
const createHistoryTypeFilter = (historyTypes) => ({
    type: 'type',
    order: 0,
    header: 'arcade.filter.historyType.label',
    key: 'HistoryType',
    value: 'historyType',
    selectionType: filters_1.SelectionType.MULTIPLE,
    filters: historyTypes.map((type, index) => ({
        name: type,
        value: type,
        isSelected: false,
        order: index
    }))
});
exports.createHistoryTypeFilter = createHistoryTypeFilter;
const customizeFilters = (filtersToCustomize, historyTypes, isHistoryTypeMultiSelect) => {
    const customize = (filterCategory, filterValues, isMultiSelect) => {
        if (!filterValues) {
            return filterCategory;
        }
        if (filterCategory.filters) {
            filterCategory.filters = filterCategory.filters
                .filter(filter => filterValues.includes(filter.value))
                .sort((x, y) => filterValues.indexOf(x.value) - filterValues.indexOf(y.value));
        }
        if (!!isMultiSelect) {
            filterCategory.selectionType = filters_1.SelectionType.MULTIPLE;
        }
        return filterCategory;
    };
    return Object.assign(Object.assign({}, filtersToCustomize), { HistoryType: customize(filtersToCustomize.HistoryType, historyTypes, isHistoryTypeMultiSelect) });
};
exports.customizeFilters = customizeFilters;
const filters = {
    HistoryType,
    DateFilter
};
exports.filters = filters;
//# sourceMappingURL=filters.js.map